module.exports = __webpack_public_path__ + "static/media/8.3b13a2db.jpg";